export default __webpack_public_path__ + "static/media/FamilyTime-hover.3dddaaa2.svg";